var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.4331 43.5672C53.0202 40.1557 48.3921 38.2393 43.5664 38.2393C38.7408 38.2393 34.1127 40.1557 30.6998 43.5672L17.8289 56.4339C14.4159 59.8469 12.4985 64.4759 12.4985 69.3027C12.4985 74.1294 14.4159 78.7584 17.8289 82.1714C21.2419 85.5844 25.871 87.5018 30.6977 87.5018C35.5244 87.5018 40.1534 85.5844 43.5664 82.1714L49.9998 75.7381",
    stroke: "white",
    strokeWidth: 8.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5664 56.4336C46.9794 59.8451 51.6074 61.7616 56.4331 61.7616C61.2587 61.7616 65.8868 59.8451 69.2997 56.4336L82.1706 43.5669C85.5836 40.1539 87.501 35.5249 87.501 30.6982C87.501 25.8715 85.5836 21.2424 82.1706 17.8294C78.7576 14.4164 74.1285 12.499 69.3018 12.499C64.4751 12.499 59.8461 14.4164 56.4331 17.8294L49.9997 24.2628",
    stroke: "white",
    strokeWidth: 8.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.9b48ef3ff71a414b3c6067ff9e4c8ae7.svg";
export { ForwardRef as ReactComponent };